import React from 'react';
import Switch from 'react-toggle-switch';
import ReactTooltip from 'react-tooltip';
import Slider from 'react-rangeslider';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import Info from '../../Widgets/info';

const TVForm = ({
  controlOpen,
  setControlOpen,
  tvNameInput,
  activeTV,
  setTvNameInput,
  handleUpdate,
  durationRef,
  toolTipContent,
  tvDurationInput,
  setTvDurationInput,
  handleDurationComplete,
  tickerRef,
  shoutTickerInput,
  handleSwitch,
  pricesRef,
  showPricesInput,
  activeTypesRef,
  activeTypes,
  handleCheckChange,
  listViewRef,
  listViewInput,
  listSpeedRef,
  listViewDurationInput,
  setListViewDurationInput,
  handleListViewComplete,
  setShowSectionToggle,
  showSectionToggle,
  allSections,
  determineIfOn,
  onFilterSectionClick,
  setShowGalleryToggle,
  showGalleryToggle,
  onAlbumClick,
  albums,
  handleViewType,
  handlePageDataChange,
}) => {
  const prettyPrintTime = time => {
    switch (time) {
      case 60:
        return '1 Minute';
      case 120:
        return '2 Minutes';
      default:
        return `${time} seconds`;
    }
  };

  const msToMinutes = time => (time / 60000).toFixed(1);

  const handleListViewRadioChange = time => {
    // setTvDurationInput(time);
    setTimeout(() => {
      handleDurationComplete(time);
    }, 1000);
  };

  const getViewOptions = () => {
    if (activeTV.otherOptions.pageViewData) {
      return [
        {
          value: 'default',
          label: 'Showcase View',
        },
        {
          value: 'list',
          label: 'List View',
        },
        {
          value: 'page',
          label: 'Page View',
        },
      ];
    } return [
      {
        value: 'default',
        label: 'Showcase View',
      },
      {
        value: 'list',
        label: 'List View',
      },
    ];
  };

  const getDropdownVal = () => {
    switch (activeTV.displayType.type) {
      case 'default':
        return {
          value: 'default',
          label: 'Showcase View',
        };
      case 'list':
        return {
          value: 'list',
          label: 'List View',
        };
      case 'page':
        return {
          value: 'page',
          label: 'Page View',
        };
    }
  };

  const handleViewChange = e => {
    handleViewType(e.value);
  };

  const getCustomOptions = () => {
    return Object.keys(activeTV.otherOptions.pageViewData);
  };

  const getCustomOptionValue = () => {
    const types = Object.keys(activeTV.otherOptions.pageViewData);
    const pageViewData = activeTV.otherOptions.pageViewData;

    const selectedType = types
      .map(type => {
        if (pageViewData[type] === true) {
          return type;
        }
      })
      .filter(itm => itm !== undefined);

    return selectedType[0];
  };

  const renderCustomPageTypes = () => (
    <Dropdown
      options={getCustomOptions()}
      value={getCustomOptionValue()}
      onChange={handlePageDataChange}
    />
  );

  const minutesToMS = time => time * 60000;
  return (
    <section className={`tv-remote ${controlOpen ? 'tv-remove__open' : ''}`}>
      <form className="remote-form">
        <div className="close-btn-container">
          <img
            src="img/close.svg"
            alt="close"
            style={{ maxWidth: '20px' }}
            onClick={() => setControlOpen(false)}
            className="close-btn"
          />
        </div>
        <div>
          <div>
            <label htmlFor="TVName">TV Name</label>
          </div>
          <div className="input-btn-row">
            <div>
              <input
                className="color-black"
                name="TVName"
                type="text"
                value={tvNameInput || activeTV.otherOptions.TVName}
                onChange={e => setTvNameInput(e.target.value)}
              />
            </div>
            <div>
              <button
                className="btn btn-primary"
                name="TVName"
                onClick={handleUpdate}
              >
                Update
              </button>
            </div>
          </div>
        </div>

        <div>
          <label htmlFor="slideDuration">
            Slide Duration (seconds)
            <span
              className="tool-tip-container"
              ref={durationRef}
              data-tip={toolTipContent.duration}
            >
              <Info />
            </span>
            <ReactTooltip
              overridePosition={({ left, top }, _e, _t, node) => {
                return {
                  top,
                  left: typeof node === 'string' ? left : Math.max(left, 0),
                };
              }}
            />
          </label>
          <div className="input-btn-row input-btn-row__radio">
            <div>
              {/* <span>{prettyPrintTime(tvDurationInput)}</span> */}
              <label htmlFor="3seconds">3s</label>
              <input
                name="3seconds"
                type="radio"
                placeholder="3"
                checked={tvDurationInput === 3}
                onChange={() => handleListViewRadioChange(3)}
              />

              <label htmlFor="5seconds">5s</label>
              <input
                name="5seconds"
                type="radio"
                placeholder="5"
                checked={tvDurationInput === 5}
                onChange={() => handleListViewRadioChange(5)}
              />

              <label htmlFor="10seconds">10s</label>
              <input
                name="10seconds"
                type="radio"
                placeholder="10"
                checked={tvDurationInput === 10}
                onChange={() => handleListViewRadioChange(10)}
              />

              <label htmlFor="3seconds">30s</label>
              <input
                name="30seconds"
                type="radio"
                placeholder="30"
                checked={tvDurationInput === 30}
                onChange={() => handleListViewRadioChange(30)}
              />

              <label htmlFor="3seconds">1m</label>
              <input
                name="60seconds"
                type="radio"
                placeholder="60"
                checked={tvDurationInput === 60}
                onChange={() => handleListViewRadioChange(60)}
              />
            </div>
          </div>
        </div>

        <div className="flex-fields">
          <div>
            <label htmlFor="ticker">
              Show Shout Ticker
              <span
                className="tool-tip-container"
                ref={tickerRef}
                data-tip={toolTipContent.ticker}
              >
                <Info />
              </span>
              <ReactTooltip
                overridePosition={({ left, top }, _e, _t, node) => {
                  return {
                    top,
                    left: typeof node === 'string' ? left : Math.max(left, 0),
                  };
                }}
              />
            </label>
            <div>
              <Switch
                on={shoutTickerInput}
                name={'showTicker'}
                onClick={() => handleSwitch('showTicker')}
              />
            </div>
          </div>
          <div>
            <label htmlFor="prices">
              Show Prices
              <span
                className="tool-tip-container"
                ref={pricesRef}
                data-tip={toolTipContent.prices}
              >
                <Info />
              </span>
              <ReactTooltip
                overridePosition={({ left, top }, _e, _t, node) => {
                  return {
                    top,
                    left: typeof node === 'string' ? left : Math.max(left, 0),
                  };
                }}
              />
            </label>
            <div>
              <Switch
                on={showPricesInput}
                onClick={() => handleSwitch('showPrices')}
              />
            </div>
          </div>
        </div>

        <div>
          <label htmlFor="activeTypes">
            Toggle displayed data
            <span
              className="tool-tip-container"
              ref={activeTypesRef}
              data-tip={toolTipContent.activeTypes}
            >
              <Info />
            </span>
            <ReactTooltip
              overridePosition={({ left, top }, _e, _t, node) => {
                return {
                  top,
                  left: typeof node === 'string' ? left : Math.max(left, 0),
                };
              }}
            />
          </label>
          <div className="flex-checkboxes">
            <div>
              <Switch
                on={activeTypes.includes('items')}
                onClick={() => handleCheckChange('items')}
              />

              <label htmlFor="menuItems">Menu Items</label>
            </div>
            <div>
              <Switch
                on={activeTypes.includes('events')}
                onClick={() => handleCheckChange('events')}
              />
              <label htmlFor="events">Events</label>
            </div>
            <div>
              <Switch
                on={activeTypes.includes('photos')}
                onClick={() => handleCheckChange('photos')}
              />
              <label htmlFor="photos">Photos</label>
            </div>
            <div>
              <Switch
                on={activeTypes.includes('shout')}
                onClick={() => handleCheckChange('shout')}
              />
              <label htmlFor="shout">Shout</label>
            </div>
          </div>
        </div>

        <div className="visibility-toggles">
          <div style={{ overflow: 'none' }}>
            <label htmlFor="listView">
              Choose View Type
              <span
                className="tool-tip-container"
                ref={listViewRef}
                data-tip={toolTipContent.listView}
              >
                <Info />
              </span>
              <ReactTooltip
                overridePosition={({ left, top }, _e, _t, node) => {
                  return {
                    top,
                    left: typeof node === 'string' ? left : Math.max(left, 0),
                  };
                }}
              />
            </label>
            <div style={{ overflow: 'none' }}>
              {/* dropdown here */}
              <Dropdown
                options={getViewOptions()}
                value={getDropdownVal()}
                onChange={handleViewChange}
              />
              {/* <Switch
                on={listViewInput}
                onClick={() => handleSwitch('listView')}
              /> */}
            </div>
          </div>
          {activeTV.otherOptions.pageViewData &&
          activeTV.displayType.type === 'page'
            ? renderCustomPageTypes()
            : ''}
          <div>
            <label htmlFor="listViewSpeed">
              List View Speed (minutes)
              <span
                className="tool-tip-container"
                ref={listSpeedRef}
                data-tip={toolTipContent.listSpeed}
              >
                <Info />
              </span>
              <ReactTooltip
                overridePosition={({ left, top }, _e, _t, node) => {
                  return {
                    top,
                    left: typeof node === 'string' ? left : Math.max(left, 0),
                  };
                }}
              />
            </label>
            <div className="input-btn-row">
              <div>
                <span>{msToMinutes(listViewDurationInput)}</span>
                <Slider
                  min={0.5}
                  max={20}
                  step={0.5}
                  value={msToMinutes(listViewDurationInput)}
                  orientation="horizontal"
                  onChange={e => setListViewDurationInput(minutesToMS(e))}
                  onChangeComplete={handleListViewComplete}
                />
              </div>
            </div>
          </div>
        </div>

        </form>
    </section>
  );
};

export default TVForm;



// WEBPACK FOOTER //
// ./src/views/Components/Modals/TVForm.js